import { Injectable } from '@angular/core';

import { LogoutResponse } from '@reach/interfaces/auth/auth.responses';
import { UserInPing } from '@reach/interfaces/user/user-in-ping';

import { BaseApiService } from '~ng-common-lib/core/api/base.api.service';

import { ClientSession } from './session.type';

@Injectable({ providedIn: 'root' })
export class AuthApiService extends BaseApiService {
	protected readonly commonPath = ['auth'];

	public async ping(): Promise<ClientSession> {
		return await this.http.get<UserInPing>(this.url('ping')).then(parseSessionFromServer);
	}

	public async login(username: string, password: string): Promise<ClientSession> {
		const body = {
			username,
			password,
		};

		return await this.http
			.post<UserInPing>(this.url('login'), body)
			.then(parseSessionFromServer);
	}

	public async logout(): Promise<LogoutResponse> {
		await this.http.post<LogoutResponse>(this.url('logout'), {});
	}
}

const parseSessionFromServer = (user: UserInPing): ClientSession => {
	return {
		userId: user.privateId,
		email: user.email,
		featureFlags: user.leader?.userFeatureFlags || user.userFeatureFlags,
		adminRole: user.leader?.adminFeatureFlags || user.adminFeatureFlags,
	};
};
